import React, { Component } from "react";
import { Api } from "../utils/api";
import { withRouter } from "react-router";
import EditCreditNote from "./components/edit_credit_note.component";
import AlertDialog from "../components/alert.component";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Invoicexpress } from "../utils/invoicexpress";

class CreditNotesView extends Component {
  state = {
    showAlert: false,
    showLoading: false,
    alertTitle: "",
    alertMessage: "",
    handleClose: this.closeAlert,
    requestInfo: {},
    invoice: {},
    entity: {},
  };

  constructor() {
    super();
    this.form = null;
    this.api = new Api();
    this.iexpress = new Invoicexpress();
    this.setForm = this.setForm.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getEntityData = this.getEntityData.bind(this);
    this.getEntityContacts = this.getEntityContacts.bind(this);
    this.showAlert = this.showAlert.bind(this);
    this.renderProgress = this.renderProgress.bind(this);
  }

  /**
   *
   */

  componentDidMount() {
    const creditNoteId = this.props.match.params.id;
    //
    return this.iexpress
      .getInvoiceData(creditNoteId, "credit_note")
      .then((data) => {
        this.setState({ invoice: data.invoice });
        return this.iexpress
          .getInvoiceClient(data.invoice.client.id)
          .then((data) => {
            this.setState({ client: data });
            const invoicexpress_client_id = data.id;
            return this.getEntityData(invoicexpress_client_id).then(() => {
              return this.getRequestInfo(creditNoteId).then((res) => {
                this.setState({ requestInfo: JSON.parse(res.extra_data) });
              });
            });
          });
      });
  }

  /**
   *
   */

  getEntityData(invoicexpress_client_id) {
    return this.api
      .get("/entities", { invoicexpress_client_id })
      .then(({ data = null }) => {
        var entity = data.entities[0];
        return this.getEntityContacts(entity.id).then(({ data = null }) => {
          entity.emails = data.emails;
          this.setState({ entity });
        });
      });
  }

  getEntityContacts(entity_id) {
    return this.api.get("/user_entities", {
      entity_id: entity_id,
      billing_contacts: true,
    });
  }

  getRequestInfo(invoiceId) {
    return this.api
      .get("/easypay_payment_invoices", { invoice_id: invoiceId })
      .then(({ data = null }) => {
        if (data.count === 0) return null;
        return data.easypay_payment_invoices[0];
      });
  }

  handleSubmit(values, actions) {
    if (!values.entity_email) {
      this.showAlert("Erro", "Não foi adicionado nenhum email para envio!");
      actions.setSubmitting(false);
      return;
    }

    if (!values.attach && values.invoice_status === "settled") {
      this.showAlert(
        "Erro",
        "Não foi adicionado o comprovativo de transferência!"
      );
      actions.setSubmitting(false);
      return;
    }

    this.renderProgress();

    let creditNoteId = values.credit_note_id;
    return this.api
      .patch(`/invoicexpress_credit_notes/${creditNoteId}`, { ...values })
      .then((res) => {
        if (res.status === 201) {
          this.showAlert("Sucesso", "Alterações guardadas com sucesso!", () =>
            this.props.history.goBack()
          );
        } else
          this.showAlert("Erro", "Ocorreu um erro a gravar as alterações!");
        actions.setSubmitting(false);
        this.renderProgress();
      })
      .catch((res) => {
        console.log(res);
        this.showAlert("Erro", "Ocorreu um erro a gravar as alterações!");
        actions.setSubmitting(false);
        this.renderProgress();
      });
  }

  /**
   *
   */

  showAlert(title, message, handleClose) {
    this.setState({ showAlert: true });
    this.setState({ alertTitle: title });
    this.setState({ alertMessage: message });
    this.setState({ handleClose: handleClose ? handleClose : this.closeAlert });
  }

  closeAlert = () => {
    this.setState({ showAlert: false });
  };

  setForm(form) {
    this.form = form;
  }

  /**
   *
   */

  renderProgress() {
    if (this.state.showLoading) this.setState({ showLoading: false });
    else this.setState({ showLoading: true });
  }

  render() {
    const invoice = this.state.invoice;

    return (
      <>
        <div className="main-reqlist-container">
          <EditCreditNote
            getForm={this.setForm}
            onSubmit={this.handleSubmit}
            client={this.state.client}
            entity={this.state.entity}
            request={this.state.requestInfo}
            {...invoice}
          />
        </div>
        <AlertDialog
          open={this.state.showAlert}
          handleClose={this.state.handleClose}
          title={this.state.alertTitle}
          message={this.state.alertMessage}
        ></AlertDialog>

        <div
          hidden={!this.state.showLoading}
          className="credit-notes-loading-div"
        >
          <CircularProgress color="primary" />
        </div>
      </>
    );
  }
}

export default withRouter(CreditNotesView);
